<!--
 * @Author: Ztq
 * @Date: 2022-11-29 10:42:38
 * @LastEditors: Ztq
 * @LastEditTime: 2022-11-29 15:40:05
 * @Description: 
 * @FilePath: \ch2-vue-components\lib\rate\src\Rate.vue
-->
<script lang="ts" setup>
import { Rate } from 'ant-design-vue';
import { useAttrs, useSlots } from 'vue';
import useForm, { readOnlySlot } from '../../form/src/useFormConfig';
import useSlot from '../../hooks/useSlot';
import type { IRateProps } from '../types';
import useFormReadOnly from '../../hooks/useFormReadOnly';

const { useExcludeSlots } = useSlot({ slots: useSlots() });

const { getBindValue } = useForm<IRateProps>({ props: null, componentName: 'rate', attrs: useAttrs() });

useFormReadOnly(getBindValue);
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<template>
  <span
    v-if="getBindValue?.readOnly || readOnlySlot in $slots"
    :class="getBindValue?.readOnlyClassName"
    :style="getBindValue?.readOnlyStyle!"
    ><slot :name="readOnlySlot" :text="getBindValue.checked"></slot
  ></span>
  <Rate v-else v-bind="getBindValue" :disabled="getBindValue?.readOnly">
    <template v-for="(slot, key) in useExcludeSlots" #[key]="scope">
      <slot :name="key" v-bind="scope ?? {}"> </slot>
    </template>
  </Rate>
</template>
